var t;(function(e){e.SUI_MAINNET="sui:mainnet",e.SUI_TESTNET="sui:testnet",e.SUI_DEVNET="sui:devnet",e.SUI_CUSTOM="sui:custom"})(t||(t={}));export{t as Chain};
